export default __webpack_public_path__ + "static/15-325876817ec118b4b134046f6775d8d6.jpg";